export const validateDetalle = values => {

    let errors = {};
    if (!values?.Cantidad) {
      errors.Cantidad = 'Cantidad Requerida';

    }
    if (!values?.Codigo) {
      errors.Codigo = 'Código Cabys Requerido';

    }
    if (values?.Codigo?.length !== 13) {
      errors.Codigo = 'Código Cabys Debe Tener 13 digitos';

    }
    if (!values?.Detalle) {
      errors.Detalle = 'Descripción Requerida';
    }
    if (!values?.PrecioUnitario || values?.PrecioUnitario < 1) {
      errors.PrecioUnitario = 'Precio Unitario Requerido';
    }
    if (!values?.CodigoComercial?.Codigo) {
      errors = {
        ...errors,
        CodigoComercial: { Codigo: 'Código Producto Requerido, ejemplo 001' }
      }
    }
    if (values?.CodigoComercial?.Codigo?.length <= 1) {
      errors = {
        ...errors,
        CodigoComercial: { Codigo: 'Código Producto debe ser de almenos 3 caracteres, ejemplo 001' }
      }
    }

    return errors;
  }

  


export const validateLineaDetalle = (values) => {

  const errors = { title:null, message: null};
  if (!values.DetalleServicio?.LineaDetalle) {
    errors.title = 'Productos Requeridos';
    errors.message = 'Debe ingresar al menos un producto a la lista';
  }
  return errors;
  
};

